import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import bookingApi from "../../api/booking/booking";
import { ui } from "../../helpers/ui";

export interface TrialClientRow {
  id: number;
  clientId: number;
  clientName: string;
  date: string;
  location: string;
  cancelled: boolean;
  trainerName: string | null;
  upcoming: boolean;
  continued: boolean;
  trialStatus: string | null;
}

const InitTrialClientsLogic = () => {
  const navigate = useNavigate();

  const [rows, setRows] = useState<TrialClientRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState<number | null>(null);

  const load = () => {
    bookingApi
      .getTrialClients()
      .then((response) => {
        if (response.status === 200) setRows(response.data ?? []);
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const onChangeStatus = (id: number, status: string | null) => {
    // Odmah prikaži izabrani status da se select ne vraća na staru vrednost
    // dok zahtev traje; posle snimanja lista se svakako ponovo učitava.
    setSavingId(id);
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, trialStatus: status } : row)),
    );
    bookingApi
      .setTrialStatus(id, status)
      .then(() => {
        load();
      })
      .catch((e) => {
        load();
        ui.alert(e.response?.data?.error?.message || "Greška");
      })
      .finally(() => setSavingId(null));
  };

  const onBack = () => navigate("/home");

  return {
    rows,
    loading,
    savingId,
    onChangeStatus,
    onBack,
  };
};

export default InitTrialClientsLogic;
